<template>
  <common-dialog ref="dialog" :title="title" width="1000px" :in-dialog="inDialog">
    <div class="index-tree-box">
      <div class="left-box">
        <div class="left-title">
          <span style="cursor: pointer;" @click="allData">所有分类</span>
          <!-- <el-button type="text" @click="createTree" icon="el-icon-circle-plus-outline"></el-button> -->
        </div>
        <div class="left-main">
          <class-tree ref="classTree" detail @on-select="treeSelect"></class-tree>
        </div>
      </div>
      <div class="right-box">
        <list ref="list" common :show-checkbox="multiple" :checkbox-fixed="false">
          <template #column v-if="selectable&&!multiple">
            <slot name="column" />
            <el-table-column label="操作" align="center" width="60" fixed="right">
              <template slot-scope="{row}">
                <el-button @click="onSelect(row)" type="text">选择</el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      </div>
    </div>
    <template slot="footer">
      <slot name="footer">
        <el-button size="mini" type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import listDialogMixins from "@/mixins/listDialog";
import commonDialog from "@/components/common/dialog";
import list from "./list";
import classTree from "./classTree/tree";

export default {
  mixins: [listDialogMixins],
  components: {
    commonDialog,
    list,
    classTree,
  },
  props: {
    title: {
      type: String,
      default: "供应商列表",
    },
  },
  data() {
    return {
      data: {
        ClassId: null,
        ClassName: "",
      },
    };
  },
  mounted() {},
  methods: {
    getData(params) {
      this.params = { ...params };
      this.$refs.list.getData(this.params);
    },
    getTree() {
      this.$nextTick(() => {
        
        this.$refs.classTree.getData();
      });
    },
    allData() {
      this.resetSelect();
      this.$refs.list.getData({ ClassId: 0 });
    },
    resetSelect() {
      this.$refs.classTree.resetSelect();
      this.data.ClassId = null;
      this.data.ClassName = "";
    },
    treeSelect(data) {
      
      if (this.data.ClassId != data.ClassId) {
        this.data.ClassId = data.ClassId;
        this.data.ClassName = data.ClassName;
        this.$refs.list.getData({ ClassId: data.ClassId });
      }
    },
  },
};
</script>